interface InternalAffairsComplaintStatusInter {
    key: string
    displayName: string
    action: boolean
    neededPermission?: string
    blockReplies: boolean // internalAffairs:extendedComplaintActions overrides block replies
    statusOrder?: number
}

export const internalAffairsComplaintStatus: InternalAffairsComplaintStatusInter[] = [
    {
        key: "awaiting_investigator",
        displayName: "Awaiting Investigator",
        action: true,
        neededPermission: "internalAffairs:extendedComplaintActions",
        blockReplies: false,
        statusOrder: 1
    },
    {
        key: "investigator_assigned",
        displayName: "Investigator Assigned",
        action: true,
        neededPermission: "internalAffairs:extendedComplaintActions",
        blockReplies: false,
        statusOrder: 2
    },
    {
        key: "pending_statement_response",
        displayName: "Pending Statement Response",
        action: true,
        blockReplies: false,
        statusOrder: 3
    },
    {
        key: "pending_creator_response",
        displayName: "Pending Creator Response",
        action: true,
        blockReplies: false,
        statusOrder: 3
    },
    {
        key: "ia_cmd_review",
        displayName: "Internal Affairs Command Review",
        action: false,
        blockReplies: true,
        statusOrder: 4
    },
    {
        key: "junior_cc_review",
        displayName: "Junior Complaint Committee Vote",
        action: false,
        blockReplies: true,
        statusOrder: 5
    },
    {
        key: "senior_cc_review",
        displayName: "Senior Complaint Committee Review",
        action: false,
        blockReplies: true,
        statusOrder: 6
    },
    {
        key: "final_reported",
        displayName: "Final Report Sent for Meeting Review",
        action: false,
        blockReplies: true,
        statusOrder: 7
    },
    {
        key: "closed",
        displayName: "Closed",
        action: false,
        blockReplies: true,
        statusOrder: 99
    },
    {
        key: "re_voting",
        displayName: "Meeting Re-Review",
        action: false,
        blockReplies: true,
        statusOrder: 8
    },
    {
        key: "complaint_frozen",
        displayName: "Complaint Frozen",
        action: true,
        neededPermission: "internalAffairs:extendedComplaintActions",
        blockReplies: false,
        statusOrder: 0
    },
]

export const InternalAffairsComplaintStatus: Map<string, InternalAffairsComplaintStatusInter> = new Map(internalAffairsComplaintStatus.map(i => [i.key, i]))